<template>
	<div id="inventoryBox">
		<h2 orientation="left" class="text-xl font-normal pt-5 pb-6">
			Transactions
		</h2>

		<table class="w-full pr-5 pl-5">
			<thead>
				<tr>
					<th>Transaction type</th>
					<th>Seller's certificate</th>
					<th>Sold as</th>
					<th>Counterparty</th>
					<th>Product</th>
					<th>Quantity</th>
					<th>Transaction Date</th>
					<th>Transaction Recorded By</th>
					<th>Date created</th>
				</tr>
			</thead>

			<tr v-for="(et, key) in tradeData" :key="'trades' + key">
				<td>
					<router-link
						:to="{
							name: 'view-transaction',
							params: { id: et.TransactionID }
						}"
						>
						{{ et.TransactionType }}
					</router-link>
				</td>
				<td>{{ et.SellersCertificateType }}</td>
				<td>{{ et.SoldAsCertificateType }}</td>
				<td>{{ et.TransactionOtherPartyOperationName }}</td>
				<td>{{ et.ProductName }}</td>
				<td v-if="et.TransactionType == 'Sale'">
					-{{ getQuantityWithUnit(et.QuantityInGrams) }}
					{{ $store.state.globalSettings.WEIGHT_UNIT.label }}
				</td>
				<td v-if="et.TransactionType == 'Purchase'">
					+{{ getQuantityWithUnit(et.QuantityInGrams) }}
					{{ $store.state.globalSettings.WEIGHT_UNIT.label }}
				</td>
				<td>{{ dateTimeFormatter(et.TransactionactionDate) }}</td>
				<td>{{ et.TransactionInitiatingPartyOperationName }}</td>
				<td>{{ dateTimeFormatter(et.TransactionactionRecordedOnDB) }}</td>
			</tr>
		</table>


		<div id="tableDiv" class="flex v-screen">
			<tbody id="transactions_summary" style="margin:auto;">
				<tr>
				<td colspan="2" rowspan="2"></td>
					<th colspan="3" scope="colgroup" style="background-color:rgb(132 132 132);color:white">Purchases</th>
					<th colspan="3" scope="colgroup">Sales</th>
				</tr>
				<tr>
					<th scope="col" class="sales_summary">Declared</th>
					<th scope="col" class="sales_summary">Assigned</th>
					<th scope="col" class="sales_summary">Delta</th>
					<th scope="col" class="purchase_summary">Declared</th>
					<th scope="col" class="purchase_summary">Assigned</th>
					<th scope="col" class="purchase_summary">Delta</th>
				</tr>
				<tr>
					<th colspan="2" >Corn</th>
					<td>56</td>
					<td>56</td>
					<td>22</td>
					<td>43</td>
					<td>72</td>
					<td>23</td>
				</tr>
				<tr>
					<th colspan="2">Soy</th>
					<td>56</td>
					<td>56</td>
					<td>22</td>
					<td>43</td>
					<td>72</td>
					<td>23</td>
				</tr>
			</tbody>

		</div>




		<!--
<div class="pt-4 mt-0 pb-6 flex">
<div class="sm:w-full md:w-full">
<mapbox
:accessToken="$store.state.globalSettings.MAP_OPTIONS.accessToken"
:map-options="getCustomMapOptions()"
@map-init="mapInitialized"
:nav-control="{ show: true, position: 'bottom-right' }"
:scale-control="{ show: true, position: 'bottom-left' }"
:fullscreen-control="{ show: false, position: 'top-left' }"
>
</mapbox>
</div>
</div>
		-->
	</div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";
import { fromGramsTo } from "../../utils/weightConverter.js";
import Mapbox from "mapbox-gl-vue";
//import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
const mapboxgl = require("mapbox-gl/dist/mapbox-gl");

export default {
	name: "InventoryView",
	created() {
		this.getAllTransactionsByUserAllOpID();
	},
	computed: {},
	data() {
		return {
			initedMap: null,
			Map: null,
			mapMarkers: [],
			onClickTxMapMarkers: [],
			tradeData: []
		};
	},
	methods: {
		onTransactionRowClick(txIn) {
			var lngLat = {
				lng: txIn.TransactionLocationGPSLon,
				lat: txIn.TransactionLocationGPSLat
			};

		this.Map.flyTo({
				center: lngLat,
				zoom: 13
			});
		},
		getCustomMapOptions() {
			var mapOptions = JSON.parse(JSON.stringify(this.$store.state.globalSettings.MAP_OPTIONS));
			mapOptions.zoom = 2;
			return mapOptions;
		},
		mapInitialized(mapIn) {
			this.initedMap = mapIn;
			//Add the geo coder
			//mapIn.addControl(this.Geocoder);
			this.Map = mapIn;
		},
		getAllTransactionsByUserAllOpID() {
			asyncRequest.ServerAPI({
				method: "GET",
				api: this.$store.state.urls.GET_ALL_TRANSACTIONS_BY_USER_ALL_OP_ID,
				onSuccessCallback: dataIn => {
					this.reorganizeTradeData(dataIn);
				},
				postData: null,
				flags: asyncRequest.M_FAIL,
				customSuccessMessage: "",
				customErrorMessage: "",
				beforeAfterCallback: false
			});
		},
		reorganizeTradeData(dataIn) {
			this.tradeData = [];
			if (!Array.isArray(dataIn.Data)) {
				return;
			}
			this.tradeData = dataIn.Data;
		},
		dateTimeFormatter(dataIn) {
			return this.$dateFns.format(new Date(dataIn), "DD-MMMM-YYYY", {
				locale: this.$dateFns.locale
			});
		},
		getQuantityWithUnit(valIn) {
			var decimalPoints = 4;
			var retVal = fromGramsTo(this.$store.state.globalSettings.WEIGHT_UNIT.value, valIn, decimalPoints);
			return retVal;
		}
	},
	components: { Mapbox }
};
</script>

<style>
#inventoryBox {
	padding: 5px 15px;
	min-height: calc(100vh - 172px);
}
#inventoryBox #map {
	height: 52vh;
}
#inventoryBox .mapboxgl-canvas {
	position: inherit !important;
}
#inventoryBox .markerpopup {
	background-image: url("https://sunrisefoods.ca/wordpress/wp-content/themes/sunrise/app/images/icon-map.png");
	background-size: cover;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	cursor: pointer;
}
#inventoryBox .cstmPopup {
	padding: 20px;
}
#inventoryBox .innerHtmlPopupTxType {
	font-weight: bold;
}
#inventoryBox .innerHtmlPopupTxDate {
	font-style: italic;
}
.sales_summary {
	background-color:rgb(132 132 132);
	color:white
}
#tableDiv{
	padding-top: 10px;
}

</style>
